'use strict';

require('jquery');

var _Router = require('./util/Router');

var _Router2 = _interopRequireDefault(_Router);

var _common = require('./routes/common');

var _common2 = _interopRequireDefault(_common);

var _home = require('./routes/home');

var _home2 = _interopRequireDefault(_home);

var _about = require('./routes/about');

var _about2 = _interopRequireDefault(_about);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Populate Router instance with DOM routes */


// Import everything from autoload


// import local dependencies
var routes = new _Router2.default({
  // All pages
  common: _common2.default,
  // Home page
  home: _home2.default,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs: _about2.default
});

// Load Events
// import external dependencies
jQuery(document).ready(function () {
  return routes.loadEvents();
});


// WEBPACK FOOTER //
// ./scripts/main.js